import makeCleanId from './makeCleanId';

/**
 * Create an id from global design text
 * @param {object} item
 * @param {bool} includeProductNameInExpression
 */
export default function makeId(item, includeProductNameInExpression = false, materialId, country, language) {
  let uncleanId;
  includeProductNameInExpression = false;
  
  // The worktop needs to be able to match with the splashback, with the "Match worktop style" button/functionality
  // therefore, the ID cannot be a combination of item.ProductNameGlobal & item.ValidDesignText, as the ID for the same expression
  // as a worktop & as a splashback will be different, as they have different range names (different ProductNameGlobal).
  // As such, default solution for ID, is to only use the ID of the expression (ValidDesignTextGlobal). Then the worktop & splashback can have the same ID.

  // However, if two expressions of a worktop has the same ID, the filter will consider it the same expression & filter out the "duplicate".
  // In the case of Wood material, several expressions exists that is the exact same expression, but different range. See example below:
  // PINNARP, Walnut / veneer
  // KARLBY, Walnut / veneer
  // BARKABODA, Walnut / veneer
  // in this case, the ID should be a combination of item.ProductNameGlobal & item.ValidDesignText, so the IDs are unique & therefore the different wood worktops
  // does not get filtered out.
  if(materialId === 'wood'){ 
    includeProductNameInExpression = true;
  }

  if (includeProductNameInExpression) {
    uncleanId = `${item.ProductNameGlobal} ${item.ValidDesignTextGlobal}`;
    if(country === 'mx' && language === 'es' || country === 'MX' && language === 'ES'){
      uncleanId = `${item.ProductNameGlobal} ${item.ValidDesignText}`;
    }
  } else {
    uncleanId = item.ValidDesignTextGlobal;
    if(country === 'mx' && language === 'es' || country === 'MX' && language === 'ES'){
      uncleanId = item.ValidDesignText;
    }
  }

  return makeCleanId(uncleanId);
}
